import getCoinData from './slider-components/get-coin-data';
import createSlider from './slider-components/create-slider'


(async () => {
    //getting coin's data
    const coinData = await getCoinData()

    //creating sliders
    const fiatMaxValue = 1000000
    const maxValue = fiatMaxValue / coinData.price
    const step = +(maxValue / 1000).toFixed()
    const defaultValue = step
    const sliderCrypto = document.querySelector('[data-noui="crypto"] [data-nouitarget]')
    const inputCrypto = document.getElementById('input-number')



    await createSlider({
        slider: sliderCrypto,
        input: inputCrypto,
        coinData,
        maxValue,
        step,
        defaultValue
    })

    const sliderFiat = document.querySelector('[data-noui="fiat"] [data-nouitarget]')
    const inputFiat = document.getElementById('input-number2')
    await createSlider({
        slider: sliderFiat,
        input: inputFiat,
        coinData,
        maxValue: fiatMaxValue,
        step: 1,
        defaultValue
    })

    inputCrypto.value = defaultValue
    let inputEvent = new Event('input', {
        bubbles: true,
        cancelable: true,
    });
    
    inputCrypto.dispatchEvent(inputEvent)

    //rendering extra coin's data on page
    
})()